import { render, staticRenderFns } from "./ArrowBackIcon.vue?vue&type=template&id=4918fc34&"
import script from "./ArrowBackIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowBackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports